import { Risk } from './risk.model';
import { DataStorage } from './data-storage.model';

export class PersonalAccidentsStorage extends DataStorage {
    insureds: any[];
    risk: Risk;
    opportunityId: string;

    constructor() {
        super();
        this.branch = 7;
        this.insureds = [];
        this.risk = new Risk();
    }
}
